export default __webpack_public_path__ + "static/media/Beach vibes1.88d16056.jpg";